import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  OutlinedInput,
  Divider,
} from "@mui/material";
import { Icon } from "@iconify/react";

import organisationType from "../../data/organisationType.json";

const dividerStyle = {
  py: 0,
  my: "2px !important",
  width: "80%",
  maxWidth: 360,
  borderRadius: 2,
  border: "0.1px solid var(--app-border)",
  borderColor: "divider",
};

const DropdownIcon = (props) => (
  <Icon icon="eva:arrow-ios-downward-fill" width={18} height={18} {...props} />
);

function TypeLabelFilter({ value, onChange, component }) {
  const safeValue = Array.isArray(value) ? value : [];
  const count = safeValue.length;

  return (
    <FormControl size="small">
      <Select
        multiple
        value={safeValue}
        onChange={(e) => onChange(e.target.value)}
        IconComponent={DropdownIcon}
        input={<OutlinedInput />}
        displayEmpty
        renderValue={() => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            <span>Type</span>

            {count > 0 && (
              <Box
                sx={{
                  minWidth: 18,
                  height: 18,
                  borderRadius: "50%",
                  backgroundColor: "#6C63FF",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {count}
              </Box>
            )}
          </Box>
        )}
        sx={{
          height: 38,
          minWidth: count ? 120 : 100,
          borderRadius: "10px",
          backgroundColor:
            component === "interpretations" ||
            component === "referred-cases" ||
            component === "centres" ||
            component === "members"
              ? "var(--app-surface)"
              : "var(--app-surface)",

          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },

          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
          },
        }}
       MenuProps={{
  PaperProps: {
    sx: {
      width: "fit-content", // dynamic width based on content
      minWidth: 180, // minimum width
      maxWidth: 400, // optional max width
      mt: 1,
      borderRadius: "10px",
      border: "1px solid var(--app-border)",
      boxShadow: "var(--app-shadow)",

      maxHeight: 6 * 48,
      overflowY: "auto",

      "&::-webkit-scrollbar": {
        width: "6px",
      },

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#D1D5DB",
        borderRadius: "10px",
      },

      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
      },
    },
  },

  disableScrollLock: true,

  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },

  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
}}
      >
        {organisationType.map((item, index) => {
          const option =
            typeof item === "string" ? item : item?.value || item?.label;

          return (
            <MenuItem
              key={option}
              value={option}
              sx={{
                minHeight: 48,
                display: "flex",
                alignItems: "center",
                py: 0.5,
                position: "relative",

                "&.Mui-selected": {
                  backgroundColor: "transparent",
                },

                "&.Mui-selected:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Checkbox
                checked={safeValue.includes(option)}
                size="small"
                sx={{
                  color: "var(--app-border)",

                  "&.Mui-checked": {
                    color: "#5751E9",
                  },

                  "& .MuiSvgIcon-root": {
                    borderRadius: "8px",
                    fontSize: 20,
                  },
                }}
              />

              <ListItemText
                primary={option}
                primaryTypographyProps={{
                  fontSize: "14px",
                  color: "var(--app-text)",
                  fontWeight: 500,
                }}
              />

              {index !== organisationType.length - 1 && (
                <Divider
                  variant="middle"
                  component="li"
                  sx={{
                    ...dividerStyle,
                    position: "absolute",
                    bottom: 0,
                    left: 16,
                    right: 16,
                    width: "auto",
                  }}
                />
              )}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default TypeLabelFilter;
